__turbopack_context__.v({
  "className": "roboto_59f0db5-module__UJl9rW__className",
  "variable": "roboto_59f0db5-module__UJl9rW__variable",
});
